/* eslint-disable @typescript-eslint/no-empty-function */
import CallToAction from '@/components/elements/CallToAction';
import FeaturesCTA from '@/components/elements/FeaturesCTA';
import FeatureSection from '@/components/elements/FeatureSection';
import SimpleHeader from '@/components/elements/SimpleHeader';
import Spacer from '@/components/elements/Spacer';
import ResourcesCarousel from '@/components/modules/ResourcesCarousel';
import { List, ListIcon, ListItem } from '@chakra-ui/react';
import { useRouter } from 'next/dist/client/router';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { BiCheck } from 'react-icons/bi';
import { NextSeo } from 'next-seo';

const FeaturesLayout = () => {
  const { push } = useRouter();
  const { t } = useTranslation(`features`);
  return (
    <>
      <NextSeo
        title={t(`page_title`)}
        description={t(`page_title`)}
        openGraph={{
          title: t(`page_title`),
          description: t(`page_description`),
        }}
      />
      <SimpleHeader title={t(`header`)} lead={t(`lead`)} />
      <FeatureSection
        image={{
          url: `/images/features/section-1.png`,
          height: 587,
          width: 573,
        }}
        title={t(`section_one.title`)}
        lead={t(`section_one.lead`)}
        button={{
          title: t(`section_one.action`),
          onClick: () => push(`/download`),
        }}
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_one.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_one.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_one.bullets.three`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_one.bullets.four`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_one.bullets.five`)}
          </ListItem>
        </List>
      </FeatureSection>
      <Spacer height={[50, null, 100]} />
      <FeatureSection
        image={{
          url: `/images/features/section-2.png`,
          height: 577,
          width: 573,
        }}
        title={t(`section_two.title`)}
        lead={t(`section_two.lead`)}
        button={{
          title: t(`section_two.action`),
          onClick: () => push(`#how-it-works`),
        }}
        isReverse
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_two.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_two.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_two.bullets.three`)}
          </ListItem>
        </List>
      </FeatureSection>
      <Spacer height={[50, null, 100]} />
      <FeatureSection
        image={{
          url: `/images/features/section-3.png`,
          height: 577,
          width: 573,
        }}
        title={t(`section_three.title`)}
        lead={t(`section_three.lead`)}
        button={{
          title: t(`section_three.action`),
          onClick: () => push(`#how-it-works`),
        }}
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_three.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_three.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_three.bullets.three`)}
          </ListItem>
        </List>
      </FeatureSection>
      <SimpleHeader
        id="how-it-works"
        type="h2"
        title={t(`mid_section.header`)}
        lead={t(`mid_section.lead`)}
      />
      <FeatureSection
        image={{
          url: `/images/features/section-4.png`,
          height: 530,
          width: 450,
        }}
        title={t(`section_four.title`)}
        lead={t(`section_four.lead`)}
        button={{
          title: t(`section_four.action`),
          onClick: () => push(`/download`),
        }}
        isReverse
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_four.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_four.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_four.bullets.three`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_four.bullets.four`)}
          </ListItem>
        </List>
      </FeatureSection>
      <Spacer height={[50, null, 100]} />
      <FeatureSection
        image={{
          url: `/images/features/section-5.png`,
          height: 530,
          width: 467,
        }}
        title={t(`section_five.title`)}
        lead={t(`section_five.lead`)}
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_five.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_five.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_five.bullets.three`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_five.bullets.four`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_five.bullets.five`)}
          </ListItem>
        </List>
      </FeatureSection>
      <Spacer height={[50, null, 100]} />
      <FeatureSection
        image={{
          url: `/images/features/section-6.png`,
          height: 724,
          width: 850,
        }}
        title={t(`section_six.title`)}
        lead={t(`section_six.lead`)}
        button={{
          title: t(`section_six.action`),
          onClick: () => push(`/download`),
        }}
        isReverse
      >
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_six.bullets.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_six.bullets.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`section_six.bullets.three`)}
          </ListItem>
        </List>
      </FeatureSection>
      <Spacer height={[50, null, 100]} />
      <FeaturesCTA />
      <Spacer height={[50, null, 100]} />
      <ResourcesCarousel />
      <Spacer height={[50, null, 100]} />
      <CallToAction />
      <Spacer height={[50, null, 100]} />
    </>
  );
};

export default FeaturesLayout;
